angular.module('logbook')
.directive('dzrUiGridAutoResize', ['gridUtil', 'uiGridConstants', function (gridUtil, uiGridConstants) {
    return {
        restrict: 'A',
        require: 'uiGrid',
        link: function($scope, $elm, $attrs, uiGridCtrl) {
            $scope.$watch($attrs.uiGrid + '.minRowsToShow', function(val) {
                var grid = uiGridCtrl.grid;

                // Figure out the new height
                var contentHeight = grid.options.minRowsToShow * grid.options.rowHeight,
                    headerHeight = grid.options.hideHeader ? 0 : grid.options.headerRowHeight,
                    footerHeight = grid.options.showFooter ? grid.options.footerRowHeight : 0,
                    scrollbarHeight = grid.options.enableScrollbars ? gridUtil.getScrollbarWidth() : 0,
                    maxNumberOfFilters = 0;

                // // Calculates the maximum number of filters in the columns
                // if (grid.options.enableFiltering) {
                //     angular.forEach(grid.options.columnDefs, function(col) {
                //         if (col.enableFiltering === false)
                //             return;
                //
                //         maxNumberOfFilters = Math.max(maxNumberOfFilters, col.filters ? col.filters.length : 1);
                //     });
                // }

                var filterHeight = maxNumberOfFilters * headerHeight,
                    newHeight = headerHeight + contentHeight + footerHeight + scrollbarHeight + filterHeight;

                $elm.css('height', newHeight + 'px');

                grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);

                // Run initial canvas refresh
                grid.refreshCanvas();
            });
        }
    };
}]);
